// extracted by mini-css-extract-plugin
export default {"navi":"ModalNavigation_navi__1CroE","prev":"ModalNavigation_prev__fwxi7","next":"ModalNavigation_next__0IHJV"};